// @flow

import React from 'react';
import { toString } from 'lodash';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';

import SubscriptionTooltip from '../../../components/ToolTip';
import Dropdown from '../../../components/Dropdown';

type Props = InjectIntlProvidedProps & {
  selected: string,
  subscriptionIsActive: boolean,
  onChange: (platform: string) => any,
};

const messages = defineMessages({
  allPlatformText: {
    id: 'filters.allPlatform',
    defaultMessage: 'Все устройства',
  },
  desktopText: {
    id: 'filters.desktop',
    defaultMessage: 'Настольный компьютер',
  },
  mobileText: {
    id: 'filters.mobile',
    defaultMessage: 'Телефон',
  },
});

const Platform = (props: Props) => {
  const disabled = !props.subscriptionIsActive;
  const { formatMessage } = props.intl;

  const platforms = [
    { label: formatMessage(messages.allPlatformText), value: '' },
    { label: formatMessage(messages.desktopText), value: 'DESKTOP', disabled },
    { label: formatMessage(messages.mobileText), value: 'MOBILE', disabled },
  ];

  return (
    <FormattedMessage
      id="subscription.unavailableTooltip"
      defaultMessage="Полный отчет доступен с 999 Business."
    >
      {message => (
        <SubscriptionTooltip disabled={!disabled} title={toString(message)}>
          <Dropdown
            name="periodDays"
            selected={toString(props.selected)}
            options={platforms}
            onChange={props.onChange}
            disabled={disabled}
          />
        </SubscriptionTooltip>
      )}
    </FormattedMessage>
  );
};

export default injectIntl(Platform);
